import React, { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";

/** A password box with a show/hide eye. Every password and PIN field in the app
 *  goes through this one component, so the toggle looks and behaves the same
 *  everywhere and nobody has to retype a long password to check a typo.
 *
 *  Takes the same props as <input>; `className` is the caller's own field
 *  styling, with room reserved on the right for the button. */
export default function PasswordInput({ className = "", ...rest }) {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <input {...rest} type={shown ? "text" : "password"} className={`${className} pr-11`} />
      <button
        type="button"
        // Not in the tab order: it is a convenience, and stopping between the
        // password box and the submit button to skip an eye is not one.
        tabIndex={-1}
        onClick={() => setShown((v) => !v)}
        aria-label={shown ? "Hide password" : "Show password"}
        aria-pressed={shown}
        title={shown ? "Hide" : "Show"}
        className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-ink-400 transition hover:text-ink-700"
      >
        {shown ? <EyeSlash size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
